function isNotLoginOrRegisterPath(pathname) {
  return !pathname ? false : !pathname.includes('/register') && !pathname.includes('/login');
}

export default isNotLoginOrRegisterPath;
